import React, { useEffect, useState , useContext} from 'react';
import { useParams } from 'react-router';
import './index.scss';
import { fetchInvitationDetails } from '../../apiCall';
import { fetchCarsOptionsData } from '../../apiCall';
import CardContent from '@mui/material/CardContent';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/system';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { Link } from 'react-router-dom';
import { fetchUpdateTravel } from '../../apiCall';
import { fetchDeleteTravel } from '../../apiCall';
import { fetchOrbits } from '../../apiCall';
import GoogleIcon from '@mui/icons-material/Google';
import {auth,provider} from "../Home/config";
import {signInWithPopup} from "firebase/auth";
import EditSadir from "../editSadir/editSadir";
import { VERSION } from '../../common/version';
import TopBaner from '../TopBaner/topBaner';
import SideBar from '../SideBar/sideBar';
import Footer from '../Footer/Footer';
import Context from '../../context/context';




const InvitationDetails = () => {
    const { id, type, date } = useParams();
    const [invitation, setInvitation] = useState({});
    const [carTypes , setCarTypes] = useState({});
    const [allOrbits , setOrbits] = useState([]);
    const [travelType , setTravelType] = useState("");
    const [carName , setCarName] = useState({});
    const [orbitName , setOrbitName] = useState({});
    const [showSpinner, setShowSpinner] = useState(true);
    const [isCustomerApproved, setIsCustomerApproved] = useState(false);
    const [showError, setShowError] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [isUser, setIsUser] = useState(false); 
    const [user , setUser]= useState({});
    const [userError, setUserError] = useState(false); 
    const [isLoading, setIsLoading] = useState(false);
    const {state, dispatch} = useContext(Context);
    const addUserDispatch = (data) => dispatch({ type: "SET_USER", payload: data });
    const version = VERSION;
 
   useEffect(()=>{
        getInvitation();
        getCarTypes();
        getOrbits(); 
    }, [])

    const getInvitation = () => {
        fetchInvitationDetails(id , type , date, function(response) {
            console.log(response)
            setShowSpinner(true);
          if (!response.result || response == null) {
            setShowSpinner(false);
            setShowError(true);
          } else {
            setInvitation(response.result);
            setCarName(invitation.carType); 
            setTravelType(response.result.travelType)
            if(response.result.isCustomerApproved !== undefined){
                setIsCustomerApproved(true)
                const invitationWithId = { ...response.result, id };
                setInvitation(invitationWithId);
            }
            setShowSpinner(false);
          }
        });
      };

      const getCarTypes = () => {
        fetchCarsOptionsData(function(response) {
          if (!response.result || response == null) {
          } else {
            setCarTypes(response.result)
          }
        });
      };

      const getOrbits = () => {
        fetchOrbits("private",function(response) {
          if (!response.result || response == null) {
          } else {
            setOrbits(response.result)
          }
        });
      };

    const handleEditInvitation = () => {
        setEditMode(true);
    }

    const handleCancelEditInvitation = () => {
        setEditMode(false);
    }

    const handleSaveEditInvitation = () => {
        setIsLoading(true);
        setEditMode(false);  
        fetchUpdateTravel(invitation, function(response){
         }).then(()=>{
           setIsLoading(false);
           alert('ההזמנה נערכה בהצלחה')
         }).catch(()=>{
            setIsLoading(false);
           alert('ארעה שגיאה בשמירת העריכה')
         });
    }

        const handleDeleteInvitation = () => {
            const confirmDelete = window.confirm('האם למחוק את הנסיעה?');
            if (confirmDelete) {
              fetchDeleteTravel(invitation, function(response) {
              })
                .then(() => {
                  setShowError(true);
                  alert('ההזמנה נמחקה בהצלחה');
                })
                .catch(() => {
                  alert('ארעה שגיאה במחיקת הנסיעה');
                });
            } 
          };

    const handleNameChange = (event) => {
        const inputValue = event.target.value;
        const onlyLetters = /^[A-Za-zא-ת\s]*$/;
      
        if (onlyLetters.test(inputValue)) {
            setInvitation({...invitation, nameOfCustomer: event.target.value});
        } else {
          alert("שם מכיל אותיות בלבד");
        }
    }
    const handleCustomerNameChange = (event) => {
        const inputValue = event.target.value;
        const onlyLetters = /^[A-Za-zא-ת\s]*$/;
      
        if (onlyLetters.test(inputValue)) {
            setInvitation({...invitation, name: event.target.value});
        } else {
          alert("שם מכיל אותיות בלבד");
        }
    }
    const handleAmountChange = (event) => {
        setInvitation({...invitation, amountOfpeoples: event.target.value});
    }
    const handleCustomerAmountChange = (event) => {
        setInvitation({...invitation, amount: event.target.value});
    }
    const handleDateChange = (event) => {
        setInvitation({...invitation, dateStartTraveling: event.target.value});
    }
    const handleCustomerDateChange = (event) => {
        setInvitation({...invitation, date: event.target.value});
    }
    const handleTimeChange = (event) => {
        setInvitation({...invitation, hourStartTraveling: event.target.value});
    }
    const handleCustomerTimeChange = (event) => {
        setInvitation({...invitation, time: event.target.value});
    }
    const handlePhoneChange = (event) => {
        const input = event.target.value;
        const phoneRegex = /^[0-9]*$/;
        if (phoneRegex.test(input)) {
            setInvitation({...invitation, phone1: event.target.value});
        }else{
            alert("  מספרים בלבד");  
        }
    }
    const handleCustomerPhoneChange = (event) => {
        const input = event.target.value;
        const phoneRegex = /^[0-9]*$/;
        if (phoneRegex.test(input)) {
          setInvitation({...invitation, phone: event.target.value});
        }else{
            alert("  מספרים בלבד");  
        }
    }
    const handleAnotherPhoneChange = (event) => {
        const input = event.target.value;
        const phoneRegex = /^[0-9]*$/;
        if (phoneRegex.test(input)) {
            setInvitation({...invitation, phone2: event.target.value});
        }else{
            alert("  מספרים בלבד");  
        }
    }
    const handleCustomerAnotherPhoneChange = (event) => {
        const input = event.target.value;
        const phoneRegex = /^[0-9]*$/;
        if (phoneRegex.test(input)) {
            setInvitation({...invitation, anotherPhone: event.target.value});
        }else{
            alert("  מספרים בלבד");  
        }
    }
    const handleCustomerNotes = (event) => {
        setInvitation({...invitation, notes: event.target.value});
    }
    const handleNotesChange = (event) => {
        setInvitation({...invitation,notes: event.target.value});
    }
    const handleChangeCarType = (event) => {
        setCarName(event.target.value)
        setInvitation({...invitation, carType: event.target.value});
    }
    const handleChangeCustomerCarType = (event) => {
        setCarName(event.target.value)
        setInvitation({...invitation, car: event.target.value , carId:event.target.value.id });
    }
    const handleChangeOrbit = (event) => {
        setOrbitName(event.target.value)
        setInvitation({...invitation, orbit: event.target.value});
    }
    const handleChangeCustomerOrbit = (event) => {
        setOrbitName(event.target.value)
        setInvitation({...invitation, orbit: event.target.value});
    }

    const handleClick = () => {
        console.log(invitation)
        signInWithPopup(auth, provider)
          .then((result) => {
            console.log(result.user);
            setUser(result.user); 
            addUserDispatch(result.user);
            if(invitation.travelType === "sadir"){
                if(invitation.passengers){
             const passenger = invitation.passengers.find(
                (pass) => pass.connectedCustomerTravel === id
              );
              console.log(passenger)
              if(passenger.customerDetails.email !== result.user.email ){
                setUserError(true);
                setIsUser(false);
                userError(true)
              } 
                }
              }
            
             console.log(invitation.data.customerDetails); 
            if (invitation.customerDetails === undefined || result.user.uid === invitation.customerDetails.uid ) {
              setIsUser(true);
            } else {
              setUserError(true);
            }
            if(result.user.uid === invitation.data.customerDetails.uid){
                setInvitation(invitation.data)
                setIsUser(true);
                setUserError(false);
            }
          })
          .catch((error) => {
          });
      };

    return (
        <div>

{!isUser && (
    <div>
            <div className='homePage'>
      <div className='logo' style={{ 'textAlign': 'center' }}>
      <p style={{'textAlign': 'right' , 'padding' : '5px'}}>VERSION {version} בס"ד </p>
        <img className="homeImage" src="/home-logo-v3.png" alt="logo-pych" />
      </div>
      {showSpinner ? <>
    <Box sx={{textAlign: 'center', margin: '50px 0'}}>
                <CircularProgress sx={{color: '#1a253a'}} size={100}></CircularProgress>
            </Box>
  </>:<></>}
      {userError && (
    <div style={{"textAlign" : "center"}}>
        לא ניתן לצפות בנסיעה כיוון שאתה לא מחובר עם החשבון ממנו הוזמנה 
    </div>
      )}
        {!showSpinner ? <>
            <button className='googleBtn' onClick={handleClick}>
      <GoogleIcon />
      התחבר עם גוגל
    </button>
  </>:<><p style={{ textAlign : 'center' , fontWeight: 'bold'}}>רק רגע מאתרים את ההזמנה שלך </p></>}
    </div>
    </div>
      )}

{isUser && ( 
    <div>
            <SideBar></SideBar>
            <div className="topBar">
<div>
      <img style={{height:'130px' , width: '600px' ,  display:'flex' , justifyContent:'center' , alignItems:'center'  , marginRight:'400px' , borderRadius:'10px' , marginTop:'10px'}} src="/topBaner.jpg" alt="logo-pych" />
      <div style={{ display:'flex' , justifyContent:'center' , alignItems:'center' , marginTop:'15px' , marginRight:'400px' }}>
      <img style={{height:'40px' , width:'70px' , marginRight:'40px' }}  src="/logo1.png" alt="logo-pych" />
      <img style={{height:'40px' , width:'70px' }}  src="/logo2.png" alt="logo-pych" />
      <img style={{height:'70px' , width:'120px' , marginLeft:'40px' }} src="/pycBlueIogo.png" alt="logo-pych" />
      </div>
      <p style={{textAlign:'center' , marginRight:'175px' , fontWeight:'bold' , color:'#488bc9' , fontSize: '10px'}}>שירות הסעות בכל רחבי אירופה</p>
    </div>
    <div className='topBarImagesMobile'>
    <img style={{width:'340px' , marginTop:'10px' , borderRadius:'10px' , height:'70px' , marginLeft:'30px'}} src="/topBaner.jpg" alt="logo-pych" />
      <img style={{width:'340px' , marginTop:'10px' , marginLeft:'30px'}} src="/LogoNew.png" alt="logo-pych" />
      <p style={{textAlign:'center' , marginLeft:'210px' , fontWeight:'bold' , color:'#488bc9' , fontSize: '12px'}}>שירות הסעות בכל ברחבי אירופה</p>
</div>

    <p
      style={{
        position: 'absolute',
        top: 0,
        right: 0,
        textAlign: 'right',
        margin: '20px',
      }}
    >
     בס"ד
    </p>
  </div>
               {/* <div className='card invitationDetailsDiv'> */}
               <div>

               <div style={{ 'textAlign': 'center'}}>
                    <img style={{height :'100px' }} src="/pycBlueIogo.png" alt="logo-pych"/>
            </div>
            { !userError && invitation.travelType === "sadir"  ? (
            <EditSadir invitation={invitation} id={id}></EditSadir>
                            ) : (
                                ""
                            )}
            {showSpinner?
            <Box sx={{textAlign: 'center', margin: '50px 0'}}>
                <CircularProgress sx={{color: '#1a253a'}} size={100}></CircularProgress>
            </Box>
            :
            <div style={{'margin': '20px'}}>
                <div>
                <div>
                                {showError && (
                                    <div style={{'textAlign' : 'center'}}>
                                        <h1>404</h1>
                                        <h3>שגיאה</h3>
                                        <p>הנסיעה נמחקה </p>
                                    <Link className='inviteLink' to={{
        pathname: '/Invite',
        state: {
          displayName: user.displayName,
          email: user.email,
          phoneNumber: user.phoneNumber,
          photoURL: user.photoURL,
          userId: user.uid
        }
      }}>
                                        <button className='optionsBtn' variant="contained" color="primary">
                                            הזמן נסיעה
                                        </button>
                                    </Link>
                                    </div>
                                )}
                            </div>

                            <div>
                                {!showError && invitation.travelType === "private" && (
                                   <div>
                                       <CardContent>
                                        {editMode ? (<div>
                                            <h4 className='titles'> עריכת הזמנה </h4>
                                        </div>) : (<div>
                                            <h4 className='titles'>ההזמנה שלך </h4>
                                        </div>)}
                                     <div>
                                     {isLoading && (
                                    <div
                                    style={{
                                    position: 'fixed',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    zIndex: 9999,
                                    padding: '20px',
                                    borderRadius: '8px',
                                    }}
                                    >
                                 <CircularProgress sx={{ color: '#3422F2' }} size={200} />
                               </div>
                               )}   
                                     </div>
                                        {isCustomerApproved ? 
                                        (<div>
                                                <div className='direction'>
                                                    <span className="fieldLabel">סוג נסיעה: {invitation?.travelType == 'private' ? 'פרטית' : 'הצטרפות להסעה'}</span>
                                              </div>
                                                <div className='direction'>
                                                    <span className="fieldLabel">שם: </span>
                                                    {editMode ? (
                                                        <input className="invitationInput" type="text" value={invitation?.name} onChange={handleCustomerNameChange} />
                                                    ) : (
                                                        <span>{invitation?.name}</span>
                                                    )}
                                                </div>
                                                <div className='direction'>
                            <span className="fieldLabel">כמות נסעים:</span>
                            {editMode ? (
                                <input className='invitationInput' type="text" value={invitation?.amount} onChange={handleCustomerAmountChange} ></input>

                            ) : (
                                <span>{invitation?.amount}</span>
                            )}
                        </div>
                        <div className='direction'>
                            <span className="fieldLabel">תאריך ושעה: </span>
                            {editMode ? (
                                <div>
                                 <input className="invitationInput" type="text" value={invitation?.date} onChange={handleCustomerDateChange} />
                                 <input className="invitationInput" type="time" value={invitation?.time} onChange={handleCustomerTimeChange} />
                                </div>
                            ) : (
                                 <span>{invitation?.date}, {invitation?.time}</span>
                            )}
                        </div>

                        <div className='direction'>
                            <span className="fieldLabel">טלפון: </span>
                            {editMode ? (
                                <input className="invitationInput" type="text" value={invitation?.phone} onChange={handleCustomerPhoneChange} />
                            ) : (
                                <span>{invitation?.phone}</span>
                            )}
                        </div>
                        <div className='direction'>
                            <span className="fieldLabel">טלפון נוסף: </span>
                            {editMode ? (
                                <input className="invitationInput" type="text" value={invitation?.anotherPhone} onChange={handleCustomerAnotherPhoneChange} />
                            ) : (
                                <span>{invitation?.anotherPhone}</span>
                            )}
                        </div>
                        <div className='direction'>
                            <span className="fieldLabel"> מסלול: </span>
                            {editMode ? (
                                <FormControl sx={{ minWidth: 100, margin: '10px 0' }}>
                                <InputLabel id="demo-simple-select-label"> מסלול</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    onChange={handleChangeOrbit}
                                    label=" מסלול"
                                    value={orbitName}
                                    autoWidth
                                >
                                    <MenuItem value="">
                                        <em></em>
                                    </MenuItem>
                                    {allOrbits?.map((orbit) =>
                                        <MenuItem key={orbit.id} value={orbit}>
                                            {orbit.name}
                                        </MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                            ) : (
                                <span>{invitation?.orbit.name}</span>
                            )}
                        </div>
                        <div className='direction'>
                            <span className="fieldLabel"> רכב: </span>
                            {editMode ? (
                                                        <div>
                                                            <FormControl sx={{ minWidth: 100, margin: '10px 0' }}>
                                                                <InputLabel id="demo-simple-select-label">סוג רכב</InputLabel>
                                                                <Select
                                                                    labelId="demo-simple-select-label"
                                                                    id="demo-simple-select"
                                                                    value={carName}
                                                                    onChange={handleChangeCustomerCarType}
                                                                    label="סוג רכב"
                                                                    autoWidth
                                                                >
                                                                    <MenuItem value="">
                                                                        <em></em>
                                                                    </MenuItem>
                                                                    {carTypes?.map((item) =>
                                                                        <MenuItem key={item.id} value={item}>
                                                                            {item?.carTypeHebrew}
                                                                        </MenuItem>
                                                                    )}
                                                                </Select>
                                                            </FormControl>
                                </div>
                            ) : (
                                // <span>{invitation?.car.carTypeHebrew}</span>
                                <></>
                            )}
                        </div>

                        <div className='direction'>
                            <span className="fieldLabel"> הערות: </span>
                            {editMode ? (
                                <input className="invitationInput" type="text" value={invitation?.notes} onChange={handleNotesChange} />
                            ) : (
                                <span>{invitation?.notes}</span>
                            )}
                        </div>
                        <div className='direction'>
                        <span className="fieldLabel"> חתימה: </span>
                            <img src={invitation?.signature} />
                         </div>
                        
                                        </div>) : 
                                        (<div>
                                              <div style={{'textAlign': 'center'}}>
                        <div className='direction'>
                        <span className="fieldLabel">סוג נסיעה: {invitation?.travelType == 'private' ? 'פרטית' : 'הצטרפות להסעה'}</span>
                        </div>
                        <div className='direction'>
                        <span className="fieldLabel"> מספר נסיעה: {invitation?.travelNumber}</span>
                        </div>
                        <div className='direction'>
                            <span className="fieldLabel">שם: </span>
                            {editMode ? (
                               <input className="invitationInput" type="text" value={invitation?.nameOfCustomer} onChange={handleNameChange} />
                            ) : (
                                <span>{invitation?.nameOfCustomer}</span>
                            )}
                        </div>
                        <div className='direction'>
                            <span className="fieldLabel">כמות נסעים:</span>
                            {editMode ? (
                                <input className='invitationInput' type="text" value={invitation?.amountOfpeoples} onChange={handleAmountChange} ></input>

                            ) : (
                                <span>{invitation?.amountOfpeoples}</span>
                            )}
                        </div>
                        <div className='direction'>
                            <span className="fieldLabel">תאריך ושעה: </span>
                            {editMode ? (
                                <div>
                                 <input className="invitationInput" type="text" value={invitation?.dateStartTraveling} onChange={handleDateChange} />
                                 <input className="invitationInput" type="time" value={invitation?.hourStartTraveling} onChange={handleTimeChange} />
                                </div>
                            ) : (
                                 <span>{invitation?.dateStartTraveling}, {invitation?.hourStartTraveling}</span>
                            )}
                        </div>
                        <div className='direction'>
                            <span className="fieldLabel">טלפון: </span>
                            {editMode ? (
                                <input className="invitationInput" type="text" value={invitation?.phone1} onChange={handlePhoneChange} />
                            ) : (
                                <span>{invitation?.phone1}</span>
                            )}
                        </div>
                        <div className='direction'>
                            <span className="fieldLabel">טלפון נוסף: </span>
                            {editMode ? (
                                <input className="invitationInput" type="text" value={invitation?.phone2} onChange={handleAnotherPhoneChange} />
                            ) : (
                                <span>{invitation?.phone2}</span>
                            )}
                        </div>
                        <div className='direction'>
                            <span className="fieldLabel"> מסלול: </span>
                            {editMode ? (
                                   <FormControl sx={{ minWidth: 100, margin: '10px 0' }}>
                                   <InputLabel id="demo-simple-select-label"> מסלול</InputLabel>
                                   <Select
                                       labelId="demo-simple-select-label"
                                       id="demo-simple-select"
                                       onChange={handleChangeOrbit}
                                       label=" מסלול"
                                       autoWidth
                                       value={orbitName}
                                   >
                                       <MenuItem value="">
                                           <em></em>
                                       </MenuItem>
                                       {allOrbits?.map((orbit) =>
                                           <MenuItem key={orbit.id} value={orbit}>
                                               {orbit.name}
                                           </MenuItem>
                                       )}
                                   </Select>
                               </FormControl>
                            ) : (
                                 <span>{invitation?.orbit?.orbitDescripionHebrew}</span>
                            )}
                        </div>
                        <div className='direction'>
                            <span className="fieldLabel"> רכב: </span>
                            {editMode ? (
                                <FormControl sx={{ minWidth: 100, margin: '10px 0' }}>
                                <InputLabel id="demo-simple-select-label">סוג רכב</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={carName}
                                    onChange={handleChangeCarType}
                                    label="סוג רכב"
                                    autoWidth
                                >
                                    <MenuItem value="">
                                        <em></em>
                                    </MenuItem>
                                    {carTypes?.map((item) =>
                                        <MenuItem key={item.id} value={item}>
                                            {item.carTypeHebrew}
                                        </MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                            ) : (
                                <span>{invitation?.carType?.carTypeHebrew}</span>
                            )}
                        </div>

                        <div className='direction'>
                            <span className="fieldLabel"> הערות: </span>
                            {editMode ? (
                                <input className="invitationInput" type="text" value={invitation?.notes} onChange={handleCustomerNotes} />
                            ) : (
                                <span>{invitation?.notes}</span>
                            )}
                        </div>
                        <div className='direction'>
                        <span className="fieldLabel"> חתימה: </span>
                            <img src={invitation?.customerSignature} />
                         </div>
                        
                    </div>
                                        </div>)}
                                        {editMode ? (
                            <div>
                            <button className='optionsBtn' onClick={handleSaveEditInvitation} variant="contained">שמור</button>
                            <button className='deleteBtn' onClick={handleCancelEditInvitation} variant="contained">ביטול</button> 
                            </div>

                        ) : (
                            <div>
                            {/* <button className='optionsBtn' onClick={handleEditInvitation} variant="contained">ערוך</button> */}
                            <button className='deleteBtn' onClick={handleDeleteInvitation} variant="contained">מחיקה</button> 
                            </div>

                        )}

                  
                    </CardContent>
                                   </div> 
                                )}
                            </div>
                </div>

            </div>}
        </div>
        </div>
      )}


    <Footer></Footer>


        </div>
    )
}

export default InvitationDetails;